import axios from 'axios';
import { Configuration } from '../models/configuration';
import { Photo } from '../models/photo';

class PhotoWebservice {

    public async getAllPhotos(): Promise<Photo[]> {
        return await axios.get('/photos').then(function(response) {
            const photos: Photo[] = response.data;
            return Promise.resolve(photos);
        }).catch(function(error) {
            return Promise.reject([]);
        });
    }
}

export const photoWebservice = new PhotoWebservice();
